module.exports = __webpack_public_path__ + "media/images/lb/449-b10a7c86f0b406241fcdf80d0500a462.svg";